import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class InvestorsService {
  constructor(private http: HttpClientService) {}

  getInvestor(id): Observable<any> {
    return this.http.get("/api/investors/" + id).pipe(tap((_) => console.log("InvestorsService.getInvestor: Ok")));
  }

  getInvestors({ name = undefined, rfc = undefined, business_name = undefined }): Observable<any> {
    const options = {
      params: { name, rfc, business_name },
    };
    return this.http.get("/api/investors", options).pipe(tap((_) => console.log("InvestorsService.getInvestors: Ok")));
  }

  getInvestorsAccounts(): Observable<any> {
    return this.http
      .get("/api/investors/bank_accounts")
      .pipe(tap((_) => console.log("InvestorsService.getInvestorsAccounts: Ok")));
  }

  putInvestor(
    id,
    { active = undefined, name = undefined, rfc = undefined, business_name = undefined, clabe = undefined }
  ): Observable<any> {
    const options = {
      active,
      name,
      rfc,
      clabe,
      business_name,
    };
    return this.http
      .put("/api/investors/" + id, options)
      .pipe(tap((_) => console.log("InvestorsService.putInvestors: Ok")));
  }

  postInvestor({ name, rfc, business_name, clabe }): Observable<any> {
    const options = {
      name,
      rfc,
      clabe,
      business_name,
    };
    return this.http
      .post("/api/investors", options)
      .pipe(tap((_) => console.log("InvestorsService.postInvestors: Ok")));
  }

  getInvestorsCxc(): Observable<any> {
    return this.http
      .get("/api/investors/valid_cxc")
      .pipe(tap((_) => console.log("InvestorsService.getInvestorsCxc: Ok")));
  }
}
